import { render, staticRenderFns } from "./ProfileGroupStatsWithChart.vue?vue&type=template&id=b88e5668"
import script from "./ProfileGroupStatsWithChart.vue?vue&type=script&lang=js"
export * from "./ProfileGroupStatsWithChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports